module.exports = __webpack_public_path__ + "img/table-lf.0d54b049.svg";